export enum OperationTypeMoveTypeEnum {
  INCREMENT = 'INCREMENT',
  DECREMENT = 'DECREMENT',
  EXCLUDE = 'EXCLUDE',
}
